import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <TrendingSection />
        <ArticlesSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}